function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react'; // import dateFormat from 'dateformat';

import { createAlert } from '../standaloneComponents.js';
import { useEnterKey, useLogin } from '../reactHooks.js';
import Dialog from '../dialog/dialog.js';
import Input from '../input/input.js';
import './login.scss';

function Login(props) {
  var {
    close,
    login: loginFunc,
    useDialog = false,
    useOauth2Login = false
  } = props;
  var [username, setUsername] = useState('');
  var [password, setPassword] = useState('');
  var login = useLogin();

  var handleButtonClick = () => {
    if (!username || !password) {
      return createAlert('Username and password are required');
    }

    loginFunc(username, password);
  };

  var handleClose = () => {
    if (useDialog && login.logInWindowOpen) {
      login.setLogInWindowOpen(false);
    }

    if (typeof close === 'function') {
      close();
    }
  };

  var onEnter = useEnterKey(handleButtonClick);
  var Container = useDialog ? Dialog : 'div';
  var dialogProps = {};

  if (useDialog) {
    dialogProps = {
      height: 180,
      width: 330,
      close: handleClose
    };
  }

  if (useOauth2Login) {
    return /*#__PURE__*/React.createElement(Container, _extends({
      className: "loginContainer"
    }, dialogProps), /*#__PURE__*/React.createElement("div", {
      className: "login"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "button",
      label: "Login with Authentik",
      onClick: () => loginFunc(),
      style: {
        margin: 0
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Container, _extends({
      className: "loginContainer"
    }, dialogProps), /*#__PURE__*/React.createElement("div", {
      className: "login"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "text",
      label: "Username",
      value: username,
      onChange: setUsername,
      onKeyUp: onEnter,
      placeholder: "Username..."
    }), /*#__PURE__*/React.createElement(Input, {
      type: "password",
      label: "Password",
      value: password,
      onChange: setPassword,
      onKeyUp: onEnter,
      placeholder: "Password..."
    }), /*#__PURE__*/React.createElement(Input, {
      type: "button",
      label: "Log In",
      onClick: () => handleButtonClick()
    })));
  }
}

export default Login;